"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Typography_1 = __importDefault(require("../../../Typography"));
var props_1 = require("../../context/props");
var Title = function () {
    var translate = (0, props_1.usePropsContext)().translate;
    return (react_1.default.createElement(Typography_1.default, null, translate('feedbackModal.addReview')));
};
exports.default = Title;
